export enum SliderTitles {
  LEARN_MORE = 'Más información',
  LANDSCAPES_BTN = 'Paisajes cautivadores de Cataluña',
  CATALUNYA = ' Cataluña',
}
